// Consistent section heading (title + optional subtitle) on the .section-title
// / .section-subtitle tokens, replacing hand-typed text-4xl md:text-5xl blocks.
export default function SectionHeader({ title, subtitle, align = 'center', className = '' }) {
  const alignment = align === 'left' ? 'text-left' : align === 'right' ? 'text-right' : 'text-center';
  return (
    <div className={`${alignment} ${className}`}>
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle max-w-2xl mx-auto">{subtitle}</p>}
    </div>
  );
}
